// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "http://api.pointnest.trangotechdevs.com:3061";
const BASE_URL = "https://api.votenow.trangotechdevs.com";

const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "887ab249-a7d0-4a87-8f92-06b8d3b535d6";

export { API_URL, BASE_URL, INITIAL_TOKEN };
